import { SimpleTransferOrderReceivingDetailPage } from "@/features/simple-transfer-order-receiving/pages/SimpleTransferOrderReceivingDetailPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/admin/receiving/simple-transfer-order/$id/detail",
)({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["simple_to_receiving.view_detail"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: SimpleTransferOrderReceivingDetailPage,
});
